import { Link } from 'react-router-dom'
// import useScrollDirection from '@/hooks/layout/useScrollDirection'
import { useThemeSync } from '@/hooks/layout/useThemeSync'
import { useCurrentConversationStore } from '@/store/useCurrentConversationStore'
import { useUIStore } from '@/store/useUIStore'
import { NotePencilIcon, SidebarSimpleIcon } from '@phosphor-icons/react'
import { cn } from '../../lib/utils'
import { Button } from '../ui/button'
import { EdelmanBrandmark } from './CustomIcons'

function DesktopHeader({ isNewChat }) {
  // const scrolledDown = useScrollDirection({ target: '#messages-scroll-area' })
  const sidebarOpen = useUIStore(state => state.isSidebarOpen)
  const toggleSidebar = useUIStore(state => state.toggleSidebar)
  const closeSidebarIfMobile = useUIStore(state => state.closeSidebarIfMobile)
  const isStreaming = useCurrentConversationStore(
    s => s.streamPhase === 'loading' || s.streamPhase === 'streaming',
  )
  const { isDark } = useThemeSync()
  const brandColors = isDark || isNewChat
    ? ['#FFFFFF', '#FFFFFF', '#FFFFFF']
    : ['#000000', '#000000', '#000000']

  return (
    <div
      id="page-header"
      className={cn(
        'h-header-height pointer-events-none absolute start-0 top-0 z-20 select-none items-center justify-between p-3 *:pointer-events-auto',
        '@[84rem]/thread:start-0 @[84rem]/thread:bg-transparent thread:end-0',
        isNewChat ? 'absolute end-0 start-0' : 'fixed',
        'hidden bg-transparent md:flex',
      )}
    >
      <div className="absolute start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2" />
      <div id="desktop-left-header-actions" className="flex items-center">
        <div className={cn('flex items-center pl-safe-offset-[-2.5rem]', sidebarOpen ? 'hidden' : '')}>
          <span className="flex" id="desktop-open-sidebar">
            <Button
            variant="ghost"
            size="icon"
              onClick={toggleSidebar}
              aria-label="Open sidebar"
              className={cn(
                'size-10 rounded-lg px-2 transition-colors duration-200 hover:bg-muted/70',
              )}
            >
              <SidebarSimpleIcon className="icon-xl-heavy text-current" />
            </Button>
          </span>
          <Button asChild variant="ghost" size="icon" className="flex hover:bg-muted/70" id="desktop-new-chat">
            <Link


              aria-label="New Chat"
              to={isStreaming ? '#' : '/chat'}
              className={cn(
                'flex size-10 items-center justify-center rounded-lg px-2 transition-colors duration-200 ',
                isStreaming && 'pointer-events-none opacity-50',
              )}
              onClick={closeSidebarIfMobile}
            >
              <NotePencilIcon className="icon-lg size-[1.3125em] text-current" />
            </Link>
          </Button>
        </div>
      </div>

      <div id="conversation-header-actions" className="flex items-center gap-2 pe-1 leading-[0]" />

      <div className="flex items-center gap-2 pe-1 leading-[0] pr-safe-offset-[-2.5rem]">
        <div className="relative flex items-center gap-4">
          <div className="group/edelman relative flex items-center gap-1.5 opacity-90 transition-all duration-700 ease-out hover:opacity-100">
            <EdelmanBrandmark
              colors={brandColors}
              stroke={isDark || isNewChat ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.28)'}
              strokeWidth={0.6}
              className="size-5 transition-all duration-700"
            />
            <span
              className={cn(
                'font-medium text-xs tracking-wide',
                isNewChat || isDark ? 'text-white/92' : 'text-foreground/88',
              )}
            >
              Edelman.ai
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopHeader
